export default __webpack_public_path__ + "static/3-e513b2ac06207b122bd2af8691e91da1.png";